module.exports = __webpack_public_path__ + "img/贸易.0b41aac4.png";